import Vue from 'vue';
import Vuex from 'vuex';
// eslint-disable-next-line import/no-cycle
import user from './modules/user';
import router from './modules/router';
import certificate from './modules/certificate'

Vue.use(Vuex);

export default new Vuex.Store({
  modules:  {
    user,
    router,
    certificate
  },
  strict: process.env.NODE_ENV !== 'production',
});